import type { OutgoingAction } from '../../services/workQueue';

// Without an id, the step's first forward edge ODO may take (its own or shared with the ortho).
export function findOdoForwardAction(
    actions: OutgoingAction[],
    actionId?: string
): OutgoingAction | undefined {
    return actions.find((a) =>
        actionId ? a.action === actionId : a.actor !== 'external' && a.direction === 'forward'
    );
}
